import { useTranslation } from 'react-i18next'

import Text from '../../Text'

import * as styles from './ChatroomMessagesUnreadDivider.module.css'

function ChatroomMessagesUnreadDivider({ elementRef }) {
  const { t } = useTranslation()

  return (
    <div className={styles.chatroomMessagesUnreadDivider} ref={elementRef}>
      <Text className={styles.label}>
        {t('Chatroom.UnreadMessagesDividerKey')}
      </Text>
    </div>
  )
}

export default ChatroomMessagesUnreadDivider
